// ============================================
// COLOR UTILITIES
// ============================================

/**
 * Get color for a score on 1-10 scale
 * Linear interpolation between Brand Gold (rgb(186, 163, 126)) and Brand Teal (rgb(19, 52, 55))
 * Low score -> Gold, High score -> Teal
 */
export function getScoreColor(score: number): string {
    // Normalize to 0-1 range (score is 1-10)
    const t = (score - 1) / 9;

    // Linear interpolation
    const r = Math.floor(186 + (19 - 186) * t);
    const g = Math.floor(163 + (52 - 163) * t);
    const b = Math.floor(126 + (55 - 126) * t);

    return `rgb(${r}, ${g}, ${b})`;
}
